/**
 * WHO-5743. `proBuyer=1` in the search URL is the toolbar toggle. It is URL
 * state only: `paramsFromQuery` never forwards it, so the server render and
 * every anonymous or regular viewer search exactly as without it.
 */
export const PRO_BUYER_URL_PARAM = "proBuyer";
export const PRO_BUYER_URL_VALUE = "1";

/**
 * What the toggle adds to the search service call for an eligible Pro Buyer:
 * a term filter on the indexed `merchant_trade_discount_enabled` boolean.
 * Never a percentage or a price.
 */
export const PRO_BUYER_SEARCH_FILTER_PARAM = "merchant_trade_discount_enabled";
export const PRO_BUYER_SEARCH_FILTER_VALUE = "true";
